module.exports = __webpack_public_path__ + "static/dohyeonkim-d2e7c89598696a22bcb8733c4e780f0f.jpeg";